import { FormItem, NumberInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import { Alert } from 'antd';
import { useWatch } from 'react-hook-form';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.RepeatableRange}`;

const PERFORMANCE_RANGE_LIMIT = 200;

export interface IRepeatableRangeRuleComponentProps {}

export function RepeatableRangeRuleComponent(
  props: IRepeatableRangeRuleComponentProps,
) {
  // const {} = props;
  const maxValue = useWatch({ name: `${fieldName}.max` });

  return (
    <>
      {maxValue > PERFORMANCE_RANGE_LIMIT && (
        <Alert
          type="warning"
          message={`Attenzione, sopra le ${PERFORMANCE_RANGE_LIMIT} unità il Widget potrebbe presentare problematiche di performance. Verificare manualmente la configurazione.`}
          showIcon
          style={{ marginBottom: '1rem' }}
        />
      )}
      <RowElement>
        <FormItem
          name={`${fieldName}.min`}
          label="Ripetizioni Minime"
          help="Numero minimo di ripetizioni."
        >
          <$SpaceCompact block size="large">
            <NumberInput name={`${fieldName}.min`} />
            <CustomValidationRuleMessage
              name={`${fieldName}.minCustomMessage`}
            />
          </$SpaceCompact>
        </FormItem>

        <FormItem
          name={`${fieldName}.max`}
          label="Ripetizioni Massime"
          help="Numero massimo di ripetizioni."
        >
          <$SpaceCompact block size="large">
            <NumberInput name={`${fieldName}.max`} />
            <CustomValidationRuleMessage
              name={`${fieldName}.maxCustomMessage`}
            />
          </$SpaceCompact>
        </FormItem>
      </RowElement>
    </>
  );
}
